/********************************************************************
 * ADOBE CONFIDENTIAL
 * __________________
 *
 *  Copyright 2024 Adobe
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 *******************************************************************/

import { Container } from '@adobe-commerce/elsie/lib';
import { SignInForm } from '@/auth/components';
import { SignInProps } from '@/auth/types';

export const SignIn: Container<SignInProps> = ({
  slots,
  labels,
  enableEmailConfirmation,
  initialEmailValue,
  formSize,
  renderSignUpLink,
  hideCloseBtnOnEmailConfirmation,
  routeRedirectOnEmailConfirmationClose,
  routeRedirectOnSignIn,
  routeForgotPassword,
  routeSignUp,
  onSuccessCallback,
  onErrorCallback,
  onSignUpLinkClick,
  apiErrorMessageOverride,
}) => {
  return (
    <div className="auth-sign-in">
      <SignInForm
        slots={slots}
        labels={labels}
        formSize={formSize}
        renderSignUpLink={renderSignUpLink}
        initialEmailValue={initialEmailValue}
        enableEmailConfirmation={enableEmailConfirmation}
        hideCloseBtnOnEmailConfirmation={hideCloseBtnOnEmailConfirmation}
        routeRedirectOnEmailConfirmationClose={
          routeRedirectOnEmailConfirmationClose
        }
        routeSignUp={routeSignUp}
        onErrorCallback={onErrorCallback}
        onSuccessCallback={onSuccessCallback}
        onSignUpLinkClick={onSignUpLinkClick}
        routeForgotPassword={routeForgotPassword}
        routeRedirectOnSignIn={routeRedirectOnSignIn}
        apiErrorMessageOverride={apiErrorMessageOverride}
      />
    </div>
  );
};
